import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {CSSTransition} from 'react-transition-group';
import {Container} from 'reactstrap';
import styled from 'styled-components';
import config from '../../../../config/app';
import Header from '../../../../common/components/Header';
import SideMenu from '../../../../common/components/SideMenu';
import '../../../assets/css/global.css';
import {withTheme} from '../../../components/HOC/withTheme';

const CustomFooter = styled.footer`
  &&& {
    background: ${({background}) => background};
    color: ${({color}) => color};
  }
`;

const ThemedA = styled.a`
  &&& {
    color: ${({color}) => color};
  }
`;

const ToHero = styled.a`
  &&& {
    color: ${({color}) => color}
  }
`;

class PageLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuCollapsed: false,
    };
  }

  toggleMenu = () => {
    this.setState({menuCollapsed: !this.state.menuCollapsed});
  };

  render() {
    const {children, t, theme} = this.props;
    const {menuCollapsed} = this.state;
    const {footer} = theme;

    return (
      <section className="d-flex flex-column flex-grow-1 relative">
        <section className="d-flex flex-column flex-grow-1 flex-shrink-0">
          <Header toggleMenu={this.toggleMenu} />
          <CSSTransition in={menuCollapsed} timeout={200} classNames="sidebar">
            <div className="app-body">
              <SideMenu toggleMenu={this.toggleMenu} />
              <div className="main">
                <Container id="content" style={{maxWidth: '100%'}}>
                  {children}
                </Container>
              </div>
            </div>
          </CSSTransition>
          <CSSTransition in={menuCollapsed} timeout={200} classNames="footer">
            <CustomFooter background={footer.background} color={footer.text} className="app-footer footer-enter custom-footer">
              <span className="rights-mention">
                <ThemedA color={footer.toHero} href="/" className="tohero-link">
                  © {config.name}
                </ThemedA>{' '}
                {new Date().getFullYear() + ' - ' + t('allRights')}
              </span>
              <span className="powered-mention">
                Powered by{' '}
                <ToHero color={footer.toHero} href="https://www.tohero.fr/" target="_BLANK" rel="noopener noreferrer" className="tohero-link">
                  toHero
                </ToHero>
              </span>
            </CustomFooter>
          </CSSTransition>
        </section>
      </section>
    );
  }
}

PageLayout.propTypes = {
  children: PropTypes.node,
  navBar: PropTypes.bool,
  t: PropTypes.func.isRequired,
  theme: PropTypes.shape({
    footer: PropTypes.shape({
      background: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      toHero: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default compose(
  withTranslation('common'),
  withTheme,
)(PageLayout);
